module.exports = __webpack_public_path__ + "static/Inter-roman.var-subset-4205477ad91e63d6d092b4e155e529a2.woff2";